/**
 * 权限初始数据
 * roleArr : 角色，新增时根据服务端订单类型值定义
 * orderTypeArr ：订单类型;
 * （门店门上： 根据小站服务端值定义)
 * （后端： 目前定义为6：标准检测，7：大检测）;
 * orderTypeArr - funArr ：订单-功能数组，value值1开始，新增时根据当前类型value最大值+1，需要与app同步定义，目前最大值为 9
 * orderTypeArr - orderStatusArr ： 订单状态;
 * （门店上门：新增时根据服务端订单类型值定义 string：大状态值-子状态值）
 * （后端：1：已发送，2：未发送，3：待拍照 ）
 * stockTypeArr ：库存类型，value值1开始，新增时根据当前类型value最大值+1，目前最大值为 3
 * stockTypeArr -funArr ：库存-功能数组，value值1开始，新增时根据当前类型value最大值+1，目前最大值为 4
 * stockTypeArr -stockStatusArr ： 库存状态,value值1开始，新增时根据当前类型value最大值+1;
 * 门店上门：（0：出库记录，1：待入库，2：待出库）；
 * 后端（无）；
 * 黄牛：（3：待入库，4：已销售，5：已退货）；
 * dataTypeArr ： 数据类型，value值1开始，新增时根据当前类型value最大值+1，目前最大值为 7
 * dataTypeArr - dateTypeArr ： 时间类型，value值1开始，新增时根据当前类型value最大值+1，（1：近七日，2：本月）
 * dataTypeArr - typeArr ： 维度类型，value值1开始，新增时根据当前类型value最大值+1，（1：个人，2：门店）
 */

const data = {
  roleArr: [
    {
      name: '门店',
      value: '0',
      authKey: '0',
      orderTypeArr: [
        {
          value: '0',
          name: '数码回收',
          num: '',
          funArr: [
            {
              value: '1',
              name: '手动建单',
              icon: 'ic_sdjd.png'
            },
            {
              value: '2',
              name: '扫码建单',
              icon: 'ic_smjd.png'
            },
            {
              value: '3',
              name: '公益回收',
              icon: 'ic_gyhs.png'
            },
            {
              value: '4',
              name: '收款',
              icon: 'ic_sk.png'
            }
          ],
          numKey: 'store_recycle',
          orderStatusArr: [
            {
              name: '进行中',
              value: '1',
              num: '',
              numKey: 'store_recycle'
            },
            {
              name: '已完成',
              value: '2'
            },
            {
              name: '已关闭',
              value: '3'
            },
            {
              name: '全部订单',
              value: '0'
            }
          ]
        },
        {
          value: '5',
          name: '商品销售',
          num: '',
          numKey: 'store_sales',
          funArr: [
            {
              value: '6',
              name: '手动建单',
              icon: 'ic_sdjd.png'
            },
            {
              value: '2',
              name: '扫码建单',
              icon: 'ic_smjd.png'
            }
          ],
          orderStatusArr: [
            {
              name: '进行中',
              value: '1',
              num: '',
              numKey: 'store_sales'
            },
            {
              name: '已完成',
              value: '2'
            },
            {
              name: '已关闭',
              value: '3'
            },
            {
              name: '全部订单',
              value: '0'
            }
          ]
        },
        {
          value: '1',
          name: '以旧换新',
          num: '',
          numKey: 'store_oldForNew',
          funArr: [
            {
              value: '4',
              name: '收款',
              icon: 'ic_sk.png'
            }
          ],
          orderStatusArr: [
            {
              name: '进行中',
              value: '1',
              num: '',
              numKey: 'store_oldForNew'
            },
            {
              name: '已完成',
              value: '2'
            },
            {
              name: '已关闭',
              value: '3'
            },
            {
              name: '全部订单',
              value: '0'
            }
          ]
        },
        {
          value: '3',
          name: '到店预约',
          num: '',
          numKey: 'store_notice',
          funArr: [
            {
              value: '4',
              name: '收款',
              icon: 'ic_sk.png'
            },
            {
              value: '5',
              name: '券码核销',
              icon: 'ic_qmhx.png'
            }
          ],
          orderStatusArr: [
            {
              name: '进行中',
              value: '1',
              num: '',
              numKey: 'store_notice'
            },
            {
              name: '已完成',
              value: '2'
            },
            {
              name: '已关闭',
              value: '3'
            },
            {
              name: '全部订单',
              value: '0'
            }
          ]
        }
      ],
      stockTypeArr: [
        {
          value: '1',
          name: '回收库存',
          funArr: [
            {
              value: '1',
              name: '合并出库',
              icon: 'ic_hbck.png',
              router: 'out-stock-batch-order'
            }
          ],
          stockStatusArr: [
            {
              name: '待入库',
              value: '1'
            },
            {
              name: '待出库',
              value: '2'
            },
            {
              name: '出库记录',
              value: '0'
            }
          ]
        }
      ],
      dataTypeArr: [
        {
          name: '回收数据',
          value: '1',
          dateTypeArr: [
            {
              name: '近7日',
              value: '1'
            },
            {
              name: '本月',
              value: '2'
            }
          ],
          typeArr: [
            {
              name: '个人',
              value: '1'
            },
            {
              name: '门店',
              value: '2'
            }
          ]
        },
        {
          name: '销售数据',
          value: '2',
          dateTypeArr: [
            {
              name: '近7日',
              value: '1'
            },
            {
              name: '本月',
              value: '2'
            }
          ],
          typeArr: [
            {
              name: '个人',
              value: '1'
            },
            {
              name: '门店',
              value: '2'
            }
          ]
        },
        {
          name: '质检数据',
          value: '3',
          dateTypeArr: [
            {
              name: '近7日',
              value: '1'
            },
            {
              name: '本月',
              value: '2'
            }
          ],
          typeArr: [
            {
              name: '个人',
              value: '1'
            }
          ]
        }
      ]
    },
    {
      name: '上门',
      value: '1',
      authKey: '1',
      orderTypeArr: [
        {
          value: '0',
          name: '数码回收',
          num: '',
          numKey: 'toDoor_recycle',
          funArr: [
            {
              value: '1',
              name: '手动建单',
              icon: 'ic_sdjd.png'
            },
            {
              value: '2',
              name: '扫码建单',
              icon: 'ic_smjd.png',
              key: 'v4.3', // 4.3版本特殊标记，当用户拥有豹哥角色，不展示上门角色下的扫码建单，此为特殊标记
            },
            {
              value: '3',
              name: '公益回收',
              icon: 'ic_gyhs.png',
              key: 'v4.3', // 4.3版本特殊标记，当用户拥有豹哥角色，不展示上门角色下的公益回收，此为特殊标记
            },
            {
              value: '9',
              name: '接单日历',
              icon: 'ic_jdrl.png'
            }
          ],
          orderStatusArr: [
            {
              name: '待联系',
              value: '1-10',
              num: '',
              numKey: 'toDoor_recycleContact'
            },
            {
              name: '进行中',
              value: '1-11,12,14,15,16',
              num: '',
              numKey: 'toDoor_recycleDoing'
            },
            {
              name: '已完成',
              value: '2'
            },
            {
              name: '已关闭',
              value: '3'
            },
            {
              name: '全部订单',
              value: '0'
            }
          ]
        },
        {
          value: '1',
          name: '以旧换新',
          num: '',
          numKey: 'toDoor_oldForNew',
          funArr: [
            {
              value: '4',
              name: '收款',
              icon: 'ic_sk.png'
            }
          ],
          orderStatusArr: [
            {
              name: '进行中',
              value: '1',
              num: '',
              numKey: 'toDoor_oldForNew'
            },
            {
              name: '已完成',
              value: '2'
            },
            {
              name: '已关闭',
              value: '3'
            },
            {
              name: '全部订单',
              value: '0'
            }
          ]
        }
      ],
      stockTypeArr: [
        {
          value: '2',
          name: '回收库存',
          funArr: [
            {
              value: '2',
              name: '合并出库',
              icon: 'ic_hbck.png',
              router: 'out-stock-batch-order'
            }
          ],
          stockStatusArr: [
            {
              name: '待入库',
              value: '1'
            },
            {
              name: '待出库',
              value: '2'
            },
            {
              name: '出库记录',
              value: '0'
            }
          ]
        }
      ],
      dataTypeArr: [
        {
          name: '回收数据',
          value: '4',
          dateTypeArr: [
            {
              name: '近7日',
              value: '1'
            },
            {
              name: '本月',
              value: '2'
            }
          ],
          typeArr: [
            {
              name: '个人',
              value: '1'
            }
          ]
        },
        {
          name: '质检数据',
          value: '5',
          dateTypeArr: [
            {
              name: '近7日',
              value: '1'
            },
            {
              name: '本月',
              value: '2'
            }
          ],
          typeArr: [
            {
              name: '个人',
              value: '1'
            }
          ]
        },
        {
          name: '上门过程数据',
          value: '6',
          dateTypeArr: [
            {
              name: '近7日',
              value: '1'
            },
            {
              name: '本月',
              value: '2'
            }
          ],
          typeArr: [
            {
              name: '个人',
              value: '1'
            }
          ]
        }
      ]
    },
    {
      name: '后端',
      value: '2',
      authKey: '2',
      orderTypeArr: [
        {
          value: '6',
          name: '标准检测',
          num: '',
          numKey: '',
          funArr: [
            {
              value: '7',
              name: '开始检测',
              icon: 'ic_ksjc.png'
            },
            {
              value: '8',
              name: '开始拍照',
              icon: 'ic_kspz.png'
            }
          ],
          orderStatusArr: [
            {
              name: '未发送',
              value: '1'
            },
            {
              name: '已发送',
              value: '2'
            },
            {
              name: '待拍照',
              value: '3'
            }
          ]
        }
        // {
        //   value: '7',
        //   name: '大检测',
        //   funArr: [
        //     {
        //       value: '7',
        //       name: '开始检测',
        //       icon: 'ic_ksjc.png'
        //     },
        //     {
        //       value: '8',
        //       name: '开始拍照',
        //       icon: 'ic_kspz.png'
        //     }
        //   ],
        //   orderStatusArr: [
        //     {
        //       name: '未发送',
        //       value: '1'
        //     },
        //     {
        //       name: '已发送',
        //       value: '2'
        //     },
        //     {
        //       name: '待拍照',
        //       value: '3'
        //     }
        //   ]
        // }
      ],
      stockTypeArr: [],
      dataTypeArr: [
        {
          name: '质检数据',
          value: '7',
          dateTypeArr: [
            {
              name: '近7日',
              value: '1'
            },
            {
              name: '本月',
              value: '2'
            }
          ],
          typeArr: [
            {
              name: '个人',
              value: '1'
            }
          ]
        }
      ]
    },
    {
      name: '豹哥',
      value: '3',
      authKey: '3',
      orderTypeArr: [
        {
          value: '0',
          name: '数码回收',
          num: '',
          numKey: '',
          funArr: [
            {
              value: '1',
              name: '手动建单',
              icon: 'ic_sdjd.png'
            }
          ],
          orderStatusArr: [
            {
              name: '待联系',
              value: '1-10',
              num: '',
              numKey: ''
            },
            {
              name: '进行中',
              value: '1-11,12,14,15,16',
              num: '',
              numKey: ''
            },
            {
              name: '已完成',
              value: '2'
            },
            {
              name: '已关闭',
              value: '3'
            },
            {
              name: '全部订单',
              value: '0'
            }
          ]
        }
      ],
      stockTypeArr: [
        {
          value: '3',
          name: '自营库存',
          funArr: [
            {
              value: '3',
              name: '录入库存',
              icon: 'ic_lrkc.png',
              router: 'seller-recorded-stock'
            },
            {
              value: '4',
              name: '库存搜索',
              icon: 'ic_kcss.png'
              // router: 'out-stock-batch-order'
            }
          ],
          stockStatusArr: [
            {
              name: '待入库',
              value: '3'
            },
            {
              name: '已销售',
              value: '4'
            },
            {
              name: '已退货',
              value: '5'
            }
          ]
        }
      ],
      dataTypeArr: []
    },
    {
      name: '已验货商家',
      value: '4',
      authKey: '4',
      orderTypeArr: [],
      stockTypeArr: [],
      dataTypeArr: []
    },
    {
      name: '第三方门店',
      value: '5',
      authKey: '5',
      orderTypeArr: [],
      stockTypeArr: [],
      dataTypeArr: []
    },
    {
      name: '外部系统',
      value: '6',
      authKey: '6',
      orderTypeArr: [],
      stockTypeArr: [],
      dataTypeArr: []
    }
  ]
};

export default data;
